import React from "react";
import { useIntl } from "react-intl";
import { DeploymentHistory, TrainingHistory } from "@/model";
import { UTCToLocalString } from "@/util/dateUtil";
import { useApplyService } from "@/query/deployment";
import { useAgentId, useDialog } from "@/hook";
import Button from "@/component/Button";
import Tooltip from "@/component/Tooltip";
import { DeploymentIcon } from "@/assets/svgs/icons";


interface TrainingHistoryTableProps {
    trainingHistories?: TrainingHistory[];
    deployHistory?: DeploymentHistory;
}

const TrainingHistoryTable: React.FC<TrainingHistoryTableProps> = (props) => {
    const { trainingHistories, deployHistory } = props;

    const intl = useIntl();
    const agentId = useAgentId();
    const dialog = useDialog();

    const { mutateAsync: deploy } = useApplyService(agentId);

    const onClickDeployBtn = () => {
        dialog.open({
            size: "md",
            title: intl.formatMessage({ id: "i10003" }),
            content: intl.formatMessage({ id: "i10008" }),
            onConfirm: deploy
        });
    };

    return (
        <div role="table"
             className="selection-table grid-table-training-history"
        >
            <div role="rowgroup"
                 className="selection-table-thead"
            >
                <div role="columnheader"
                     className="selection-table-th pl-[25px]"
                >
                    {intl.formatMessage({ id: "i10027" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[25px]"
                >
                    {intl.formatMessage({ id: "i10028" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                >
                    {intl.formatMessage({ id: "i10029" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                >
                    {intl.formatMessage({ id: "i10031" })}
                </div>
                <div role="columnheader"
                     className="selection-table-th pl-[15px]"
                />
            </div>
            <div role="rowgroup"
                 className="selection-table-tbody"
            >
                {trainingHistories?.map((history, index) => (
                    <div key={history.id}
                         role="row"
                         className="selection-table-tr no-hover"
                    >
                        <div role="cell"
                             className="selection-table-td pl-[25px] tabular-nums"
                        >
                            {intl.formatMessage({ id: "b0019" }, { version: history.version })}
                        </div>
                        <div role="cell"
                             className="selection-table-td pl-[25px]"
                        >
                            {UTCToLocalString(history.created_at, "YYYY-MM-DD HH:mm")}
                        </div>
                        <div role="cell"
                             className="selection-table-td pl-[15px]"
                        >
                            {history.actor ? `${history.actor.name} (${history.actor.email})` : "-"}
                        </div>
                        <div role="cell"
                             className="selection-table-td pl-[15px]"
                        >
                            <span className="long-text-wrapper">
                                {history.description ?? ""}
                            </span>
                        </div>
                        <div role="cell"
                             className="selection-table-td pl-[15px]"
                        >
                            {deployHistory?.version === history.version && (
                                <div className="flex items-center gap-1">
                                    <div className="badge-info">
                                        {intl.formatMessage({ id: "i10032" })}
                                    </div>
                                    <Tooltip placement="left"
                                             message={
                                                <div className="flex flex-col">
                                                    <div>
                                                        {intl.formatMessage({ id: "i10036" })} {UTCToLocalString(deployHistory?.created_at, "YYYY-MM-DD HH:mm")}
                                                    </div>
                                                    <div>
                                                        {intl.formatMessage({ id: "i10037" })} {deployHistory?.actor ? `${deployHistory?.actor.name} (${deployHistory?.actor.email})` : "-"}
                                                    </div>
                                                </div>
                                             }
                                    />
                                </div>
                            )}
                            {index === 0 && deployHistory?.version !== history.version && (
                                <Button variant="text"
                                        className="pl-2"
                                        onClick={onClickDeployBtn}
                                >
                                    <DeploymentIcon className="size-4" />
                                    {intl.formatMessage({ id: "i10003" })}
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
                {!trainingHistories?.length && (
                    <div className="empty-table">
                        {intl.formatMessage({ id: "i10033" })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TrainingHistoryTable;
